import { z } from 'zod';
// The building type an offer request relates to.
export const offerRequestBuildingTypeSchema = z.enum(['FAMILY_HOUSE', 'APARTMENT', 'BUSINESS', 'OTHER']);
export const OfferRequestBuildingType = offerRequestBuildingTypeSchema.enum;
